export class Tenant {
  tenant_id: number;
  domain: string;
  title: string;
  logo_name: string;
  footer: string;
  first_name: string;
  last_name: string;
  company: string;
  phone: number;
  email: string;
  address: string;
  country_id: number;
  timezone_id: number;
  active: number;
  daily_limit: number = 5000;
  monthly_limit: number = 5000;
  permissions: any;
  min_retention: number = 1;
  max_retention: number = 7;
  retention_period: number;
  sendfax;string;
  total_inbound:any;
  roles:string;
  daily_sent:number;
  mfa_enabled: boolean;
}